module.exports = __webpack_public_path__ + "static/media/iki-logo.c5a95de6.png";